import { useEffect, useState } from 'react';

import {
  disablePushNotifications,
  enablePushNotifications,
  getPushNotificationState,
} from '@/services/pushNotifications.service';
import ToggleSwitch from '@/shared-components/toggles/ToggleSwitch';

export default function PushDevicePreferenceControl({ t }) {
  const [status, setStatus] = useState('loading');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    getPushNotificationState()
      .then((nextStatus) => { if (mounted) setStatus(nextStatus); })
      .catch(() => { if (mounted) setStatus('unavailable'); });
    return () => { mounted = false; };
  }, []);

  const canChange = status === 'enabled' || status === 'disabled';

  async function handleChange(nextEnabled) {
    if (!canChange || saving) return;
    setSaving(true);
    setError('');
    try {
      if (nextEnabled) {
        await enablePushNotifications();
        setStatus('enabled');
      } else {
        await disablePushNotifications();
        setStatus('disabled');
      }
    } catch (requestError) {
      setError(requestError.message || t('push.error'));
      setStatus(await getPushNotificationState().catch(() => 'unavailable'));
    } finally {
      setSaving(false);
    }
  }

  const statusKey = status === 'blocked' || status === 'unsupported' || status === 'unavailable'
    ? status
    : 'description';

  return (
    <section className="notification-preferences__device-control" aria-labelledby="push-device-title">
      <div>
        <h3 id="push-device-title" className="notification-preferences__section-title">{t('push.device_title')}</h3>
        <p className="notification-preferences__device-description">{t(`push.${statusKey}`)}</p>
      </div>
      <ToggleSwitch
        ariaLabel={t('push.device_title')}
        checked={status === 'enabled'}
        disabled={!canChange || saving}
        onChange={handleChange}
      />
      {error ? <p className="notification-preferences__save-error" role="alert">{error}</p> : null}
    </section>
  );
}
